import { render, staticRenderFns } from "./LeftThird.vue?vue&type=template&id=2e460df3&scoped=true"
import script from "./LeftThird.vue?vue&type=script&lang=js"
export * from "./LeftThird.vue?vue&type=script&lang=js"
import style0 from "./LeftThird.vue?vue&type=style&index=0&id=2e460df3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e460df3",
  null
  
)

export default component.exports